import * as css from './LecturerSticker.css';

interface LectureStickerProps {
    color?: string | null;
    expanded?: boolean;
}

function LectureSticker({color, expanded = false}: LectureStickerProps) {
    return (
        <css.container $color={color} $expanded={expanded}>
            <css.star>⭐</css.star>
        </css.container>
    );
}

export default LectureSticker;
